/* Spanish catalog mirroring locale-superplumma-workspace-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'route.superplumma': 'SuperPlumma',
  'nav.superplumma': 'SuperPlumma',
  'navhelp.superplumma': 'Trabaja con SuperPlumma en el chat y sigue la tarea en el espacio de trabajo.',
  'spw.eyebrow': 'Tu asistente contable',
  'spw.intro': '¿Qué hacemos hoy? Pídeme que cree una factura o sube un recibo. El documento aparece a medida que trabajamos en él.',
  'spw.upload': 'Subir recibo',
  'spw.camera': 'Hacer foto',
  'spw.dropHint': 'También puedes soltar un recibo aquí.',
  'spw.drop': 'Suelta aquí tu recibo',
  'spw.uploading': 'Subiendo recibo …',
  'spw.uploadError': 'No se pudo subir el recibo.',
  'spw.saveDraft': 'Guardar borrador',
  'spw.issued': 'La factura se ha emitido.',
  'spw.showProposal': 'Mostrar propuesta',
  'spw.editDetails': 'Editar detalles',
  'spw.addReceipt': 'Sube un recibo en el chat o haz una foto.',
  'spw.proposal': 'Asiento propuesto',
  'spw.supplierMissing': 'Ningún proveedor seleccionado',
  'spw.account': 'Cuenta',
  'spw.vat': 'IVA',
  'spw.notSelected': 'Sin seleccionar',
  'spw.readingHint': 'La propuesta aparece cuando se analiza el recibo o se introducen los detalles.',
  'spw.paymentAccount': 'Cuenta de pago',
  'spw.unpaid': 'Pendiente de pago',
  'spw.approvalHint': 'Pide a SuperPlumma que contabilice cuando la propuesta esté lista. Podrás revisar y aprobar la acción.',
  'spw.openTask': 'Abrir tarea',
  'spw.chat': 'Chat',
  'spw.workspace': 'Espacio de trabajo',
  'spw.shared': 'Un único conjunto de cuentas. Visibilidad total.',
  'spw.receipts': 'Documentos',
  'spw.purchase': 'Compras',
  'spw.sale': 'Ventas',
  'spw.invoice': 'Borrador de factura',
  'spw.choose': 'Elige una tarea',
  'spw.loading': 'Abriendo el espacio de trabajo …',
  'spw.loadError': 'No se pudo cargar el espacio de trabajo. Tu conversación se ha conservado.',
  'spw.retry': 'Intentar de nuevo',
  'spw.unavailable': 'Abre SuperPlumma en una empresa activa para empezar.',
  'spw.changeTitle': '¿Cambiar de tarea?',
  'spw.changeText': 'Guarda los cambios del formulario antes de cambiar de tarea. Los cambios sin guardar pueden perderse.',
  'spw.changeConfirm': 'Cambiar de tarea',
});
